import { defineStore } from 'pinia'
import { buildAideUrl } from '@/utils/build-aide-url'

export const useAideDrawerStore = defineStore('aideDrawer', {
  state: () => ({
    visible: false,
    /** 已选团队且 AI 助手订阅生效后写入；抽屉开关复用同一实例 */
    iframeSrc: null as string | null,
    /** 切换已订阅团队时递增，强制重挂 iframe */
    iframeEpoch: 0,
    preparedTeamId: null as number | null,
    /** 是否允许毒霸登录 / init。仅订阅生效且 iframe 挂着时为 true */
    bootEnabled: false,
  }),
  actions: {
    /**
     * 已选团队且订阅生效后挂上 iframe（不打开抽屉）。
     * 登录初始化由 bootEnabled + bridge forceBoot 控制。
     */
    prepare (teamId: number) {
      if (!teamId) return
      if (this.preparedTeamId === teamId && this.iframeSrc) return
      const switchingTeam = this.preparedTeamId != null && this.preparedTeamId !== teamId
      this.preparedTeamId = teamId
      if (switchingTeam) {
        this.visible = false
        this.iframeEpoch += 1
      }
      if (!this.iframeSrc) {
        this.iframeSrc = buildAideUrl()
      }
    },
    setBootEnabled (enabled: boolean) {
      this.bootEnabled = enabled
    },
    /** 登出、未选团队、未订阅或已过期：卸掉 iframe */
    release () {
      if (!this.iframeSrc && this.preparedTeamId == null && !this.bootEnabled) return
      this.visible = false
      this.iframeSrc = null
      this.preparedTeamId = null
      this.bootEnabled = false
      this.iframeEpoch += 1
    },
    open () {
      if (!this.bootEnabled) return
      if (!this.iframeSrc) {
        this.iframeSrc = buildAideUrl()
      }
      this.visible = true
    },
    close () {
      this.visible = false
    },
  },
})
